import { render } from "./MeasureDefinitionTabView.vue?vue&type=template&id=daff19ae&scoped=true&ts=true"
import script from "./MeasureDefinitionTabView.vue?vue&type=script&lang=ts"
export * from "./MeasureDefinitionTabView.vue?vue&type=script&lang=ts"

import "./MeasureDefinitionTabView.vue?vue&type=style&index=0&id=daff19ae&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daff19ae"]])

export default __exports__